import { ICountryCodeDropDownData } from './CountryCodeDropDown.types';

export const countryCodes: Array<ICountryCodeDropDownData> = [
  {
    name: 'Albania',
    code: 'AL',
    phoneCode: '+355',
    flag: '🇦🇱',
  },
  {
    name: 'Andorra',
    code: 'AD',
    phoneCode: '+376',
    flag: '🇦🇩',
  },
  {
    name: 'Armenia',
    code: 'AM',
    phoneCode: '+374',
    flag: '🇦🇲',
  },
  {
    name: 'Austria',
    code: 'AT',
    phoneCode: '+43',
    flag: '🇦🇹',
  },
  {
    name: 'Belarus',
    code: 'BY',
    phoneCode: '+375',
    flag: '🇧🇾',
  },
  {
    name: 'Belgium',
    code: 'BE',
    phoneCode: '+32',
    flag: '🇧🇪',
  },
  {
    name: 'Bosnia and Herzegovina',
    code: 'BA',
    phoneCode: '+387',
    flag: '🇧🇦',
  },
  {
    name: 'Bulgaria',
    code: 'BG',
    phoneCode: '+359',
    flag: '🇧🇬',
  },
  {
    name: 'Croatia',
    code: 'HR',
    phoneCode: '+385',
    flag: '🇭🇷',
  },
  {
    name: 'Cyprus',
    code: 'CY',
    phoneCode: '+357',
    flag: '🇨🇾',
  },
  {
    name: 'Czech Republic',
    code: 'CZ',
    phoneCode: '+420',
    flag: '🇨🇿',
  },
  {
    name: 'Denmark',
    code: 'DK',
    phoneCode: '+45',
    flag: '🇩🇰',
  },
  {
    name: 'Estonia',
    code: 'EE',
    phoneCode: '+372',
    flag: '🇪🇪',
  },
  {
    name: 'Faroe Islands',
    code: 'FO',
    phoneCode: '+298',
    flag: '🇫🇴',
  },
  {
    name: 'Finland',
    code: 'FI',
    phoneCode: '+358',
    flag: '🇫🇮',
  },
  {
    name: 'France',
    code: 'FR',
    phoneCode: '+33',
    flag: '🇫🇷',
  },
  {
    name: 'Georgia',
    code: 'GE',
    phoneCode: '+995',
    flag: '🇬🇪',
  },
  {
    name: 'Germany',
    code: 'DE',
    phoneCode: '+49',
    flag: '🇩🇪',
  },
  {
    name: 'Gibraltar',
    code: 'GI',
    phoneCode: '+350',
    flag: '🇬🇮',
  },
  {
    name: 'Greece',
    code: 'GR',
    phoneCode: '+30',
    flag: '🇬🇷',
  },
  {
    name: 'Hungary',
    code: 'HU',
    phoneCode: '+36',
    flag: '🇭🇺',
  },
  {
    name: 'Iceland',
    code: 'IS',
    phoneCode: '+354',
    flag: '🇮🇸',
  },
  {
    name: 'Ireland',
    code: 'IE',
    phoneCode: '+353',
    flag: '🇮🇪',
  },
  {
    name: 'Italy',
    code: 'IT',
    phoneCode: '+39',
    flag: '🇮🇹',
  },
  {
    name: 'Kosovo',
    code: 'XK',
    phoneCode: '+383',
    flag: '🇽🇰',
  },
  {
    name: 'Latvia',
    code: 'LV',
    phoneCode: '+371',
    flag: '🇱🇻',
  },
  {
    name: 'Liechtenstein',
    code: 'LI',
    phoneCode: '+423',
    flag: '🇱🇮',
  },
  {
    name: 'Lithuania',
    code: 'LT',
    phoneCode: '+370',
    flag: '🇱🇹',
  },
  {
    name: 'Luxembourg',
    code: 'LU',
    phoneCode: '+352',
    flag: '🇱🇺',
  },
  {
    name: 'Malta',
    code: 'MT',
    phoneCode: '+356',
    flag: '🇲🇹',
  },
  {
    name: 'Moldova',
    code: 'MD',
    phoneCode: '+373',
    flag: '🇲🇩',
  },
  {
    name: 'Monaco',
    code: 'MC',
    phoneCode: '+377',
    flag: '🇲🇨',
  },
  {
    name: 'Montenegro',
    code: 'ME',
    phoneCode: '+382',
    flag: '🇲🇪',
  },
  {
    name: 'Netherlands',
    code: 'NL',
    phoneCode: '+31',
    flag: '🇳🇱',
  },
  {
    name: 'North Macedonia',
    code: 'MK',
    phoneCode: '+389',
    flag: '🇲🇰',
  },
  {
    name: 'Norway',
    code: 'NO',
    phoneCode: '+47',
    flag: '🇳🇴',
  },
  {
    name: 'Poland',
    code: 'PL',
    phoneCode: '+48',
    flag: '🇵🇱',
  },
  {
    name: 'Portugal',
    code: 'PT',
    phoneCode: '+351',
    flag: '🇵🇹',
  },
  {
    name: 'Romania',
    code: 'RO',
    phoneCode: '+40',
    flag: '🇷🇴',
  },
  {
    name: 'Russia',
    code: 'RU',
    phoneCode: '+7',
    flag: '🇷🇺',
  },
  {
    name: 'San Marino',
    code: 'SM',
    phoneCode: '+378',
    flag: '🇸🇲',
  },
  {
    name: 'Serbia',
    code: 'RS',
    phoneCode: '+381',
    flag: '🇷🇸',
  },
  {
    name: 'Slovakia',
    code: 'SK',
    phoneCode: '+421',
    flag: '🇸🇰',
  },
  {
    name: 'Slovenia',
    code: 'SI',
    phoneCode: '+386',
    flag: '🇸🇮',
  },
  {
    name: 'Spain',
    code: 'ES',
    phoneCode: '+34',
    flag: '🇪🇸',
  },
  {
    name: 'Sweden',
    code: 'SE',
    phoneCode: '+46',
    flag: '🇸🇪',
  },
  {
    name: 'Switzerland',
    code: 'CH',
    phoneCode: '+41',
    flag: '🇨🇭',
  },
  {
    name: 'Turkey',
    code: 'TR',
    phoneCode: '+90',
    flag: '🇹🇷',
  },
  {
    name: 'United Kingdom',
    code: 'UK',
    phoneCode: '+44',
    flag: '🇬🇧',
  },
  {
    name: 'Ukraine',
    code: 'UA',
    phoneCode: '+380',
    flag: '🇺🇦',
  },
];
